import { Avatar, Button, Col, Typography } from "antd";
import { DeleteOutlined, EditOutlined, OrderedListOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { bannersService, rankingsService } from "../../../shared/services";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";
import { DataBanner } from "../../../redux/@types";
import { useBanners, useTableBanners } from "../hooks";

const { Title } = Typography;

export const TableBanners = () => {
  const { showDeleteConfirm, changeBannersForUpdate } = useTableBanners();
  const { setTableProps, changeNavToBannersProducts, updateStatus, isLoading } = useBanners();

  const columns: TableColumns<DataBanner> = [
    {
      title: "ID",
      width: 5,
      dataIndex: "id",
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Vista en móvil",
      width: 7,
      dataIndex: "path_movile",
      key: "path_movile",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Avatar size={64} src={`${PATH_S3_BUCKET}/${item.path_movile}`} />
          </Col>
        );
      },
    },
    {
      title: "Vista en escritorio",
      width: 7,
      dataIndex: "path_desktop",
      key: "path_desktop",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Avatar size={64} src={`${PATH_S3_BUCKET}/${item.path_desktop}`} />
          </Col>
        );
      },
    },
    {
      title: "Tipo",
      width: 10,
      dataIndex: "type",
      key: "type",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
            disabled={isLoading}
              onClick={()=>{
                if(item.status === "active"){
                  updateStatus("inactive", item.id)
                }else if( item.status === "inactive"){
                  updateStatus("active", item.id)
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Prioridad",
      width: 6,
      dataIndex: "priority",
      key: "priority",
      filterType: "text",
    },
    {
      title: "Tipo de acción",
      width: 10,
      dataIndex: "action_type",
      key: "action_type",
      filterType: "text",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeBannersForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            {
              item.action_type === "BANNER_PRODUCTS" && (
                <Button
                 type="dashed"
                 shape="circle"
                 onClick={() =>changeNavToBannersProducts(item.id)}
                 icon={<OrderedListOutlined />}
                 size="large"
               />

              )
            }
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.id}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataBanner>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={bannersService}
      onLoad={setTableProps}
    />
  );
};
